export default 'https://tme.understood.org/assets/brocoli.d5561859.lottie'